// Mirrors backend/ranks_config.py — keep these in sync.
import { EMERGENCY_TYPES } from "@/lib/gameConfig";

export const RANK_TIERS = [
  { id: "rookie",      label: "Rookie",          xp: 0 },
  { id: "firefighter", label: "Firefighter",     xp: 100 },
  { id: "engineer",    label: "Engineer",        xp: 500 },
  { id: "lieutenant",  label: "Lieutenant",      xp: 1_500 },
  { id: "captain",     label: "Captain",         xp: 4_000 },
  { id: "battalion",   label: "Battalion Chief", xp: 10_000 },
  { id: "deputy",      label: "Deputy Chief",    xp: 25_000 },
  { id: "chief",       label: "Fire Chief",      xp: 60_000 },
];

// Fallback when an emergency type doesn't declare an `xp` value.
export const CALL_XP_DEFAULT = 25;

// XP for resolving a call of the given type. Reads from `EMERGENCY_TYPES.xp`
// (single source of truth) so the missions spreadsheet stays authoritative.
export function xpForCall(typeId) {
  const t = EMERGENCY_TYPES[typeId];
  if (t && typeof t.xp === "number") return t.xp;
  return CALL_XP_DEFAULT;
}
